// Moving to another workspace from inside one (02-DESIGN/03-console/01-the-console.md
// § the shape: the workspace menu; § the surfaces: Workspaces; hq decision
// 0069 points 5 and 6): a pick in the rail's workspace menu, a child's row
// there, and a child's *Open Northwind* go to that workspace's address in
// the same tab. A membership's row is the consent: the session names it
// before the page moves, so the *Entering Northwind signs you out of Acme*
// page is not shown. A child the sign-in is not a member of is its own
// sign-in page, and the session stays with this workspace (./pick.ts).

import { createContext, useContext, type ReactNode } from "react";

import type { Membership } from "../../wire/identity.ts";

/** Moves is what the shell may do to leave this workspace for another. */
export interface Moves {
  /** Whether the sign-in is the platform's: the one sign-in with memberships to list. */
  onPlatform: boolean;
  /** Whether the platform profile allows sign-up: *Create a workspace*. */
  signUp: boolean;
  /**
   * enter goes to a workspace in this tab: its Home where it is one of the
   * platform sign-in's memberships, and otherwise its own sign-in page.
   * `member` says so where the caller knows — a membership's row — and is
   * otherwise read from the memberships. It asks first where the page holds
   * unsaved changes.
   */
  enter: (slug: string, member?: boolean) => void;
  /** all is *All workspaces*: Choose a workspace, where the memberships are read again. */
  all: () => void;
  /** create is *Create a workspace*: Choose a workspace with its form open. */
  create: () => void;
  /** elsewhere is *Sign in somewhere else*: the sign-in page at `/`. */
  elsewhere: () => void;
  /** memberships reads the person's memberships on a connection to the plane that lasts for the read, once a sign-in. */
  memberships: (signal?: AbortSignal) => Promise<Membership[]>;
}

const MovesContext = createContext<Moves | undefined>(undefined);

export function MovesProvider({ value, children }: { value: Moves; children: ReactNode }) {
  return <MovesContext.Provider value={value}>{children}</MovesContext.Provider>;
}

/** useMoves answers the shell's moves, or undefined outside a workspace's console. */
export function useMoves(): Moves | undefined {
  return useContext(MovesContext);
}
